<template>
  <div>
    <v-toolbar dark color="#FF6F00">
      <v-btn @click="back()" icon>
        <v-icon small>fas fa-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Wishlist</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-text-field label="Cari wishlist.." prepend-inner-icon="fas fa-search" solo dense outlined></v-text-field>
      <div v-for="wish in wishlist" :key="wish.id">
        <v-card raised width="40%" class="pa-3 my-3 mx-auto">
          <v-row>
            <v-col>
              <v-avatar height="100" width="100" tile>
                <img :src="getImageUrl(wish.gambar)" alt="John" />
              </v-avatar>
            </v-col>
            <v-col>
              <div class="font-1">{{wish.nama}}</div>
              <div class="font-2">{{wish.harga | currency}}</div>
              <div class="font-3">{{wish.nama_toko}}</div>
              <div>
                <v-rating color="#FFEE58" half-increments v-model="rating"></v-rating>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-btn @click="deleteWish(wish)" outlined color="success">
                <v-icon>fas fa-trash</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="9">
              <v-btn
                @click="addToCart(wish)"
                block
                color="#FF6F00"
                outlined
                dark
              >Tambah ke keranjang</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-container>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      wishlist: [],
      userid: localStorage.getItem("user_id"),
      rating: 3.5,
      catatan: null
    };
  },
  mounted() {
    if (this.userid != null) {
      this.getWishlist();
    } else {
      this.$router.push("/login");
    }
  },
  methods: {
    getWishlist() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/tabel/selwishlist/" +
          this.userid
      )
        .then(response => response.json())
        .then(data => {
          this.wishlist = data;
        });
    },
    deleteWish(data) {
      Swal.fire({
        title: "Hapus wishlist ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Hapus"
      }).then(result => {
        if (result.value) {
          fetch("http://meridinet.saebo.id:2082/Login/api/tabel/delwishlist", {
            method: "POST",
            body: JSON.stringify({
              user_id: this.userid,
              id_barang: data.id
            }),
            headers: {
              "Content-type": "application/json"
            }
          })
            .then(response => response.json())
            .then(data => {
              if (data == 200) {
                this.getWishlist();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Terjadi kesalahan jaringan"
                });
              }
            });
        }
      });
    },
    getImageUrl(e) {
      if (e != null) {
        var x = e.replace(/\.[^/.]+$/, "");
        return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
      }
    },
    back() {
      window.history.back();
    },
    addToCart(data) {
      if (this.userid != null) {
        Swal.fire({
          title: "Jumlah Item yang Dibeli",
          input: "number",
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: "Ok"
        }).then(result => {
          if (result.value) {
            fetch("http://meridinet.saebo.id:2082/Login/api/tabel/addchart", {
              method: "POST",
              body: JSON.stringify({
                userid: this.userid,
                nama_toko: data.nama_toko,
                idbarang: data.idbarang,
                qty: result.value,
                harga: data.harga,
                catatan: this.catatan,
                kurir: null
              }),
              headers: {
                "Content-type": "application/json"
              }
            })
              .then(response => response.json())
              .then(data => {
                if (data.Error == 404) {
                  this.addAlamat = true;
                } else if (data.Error != 404) {
                  Swal.fire("Sukses", "Barang Ditambahkan", "success");
                  window.history.back();
                }
              });
          }
        });
      } else if (this.userid == null) {
        this.$router.push("/login");
      }
    }
  }
};
</script>
<style scoped>
.font-1 {
  font-size: 100%;
  font-weight: 900;
}
.font-2 {
  font-size: 95%;
  font-weight: 800;
  color: red;
}
.font-3 {
  font-size: 85%;
  font-weight: 400;
}
</style>